<div class="content">
  <div class="external-hint">
    {{ 'AUTOMATIONS.EDITOR.TASKS.SEND_NOTIFICATIONS.SEND_NOTIFICATION_TO' | translate }}
  </div>
  <automata-automation-replacement-chips
    label="AUTOMATIONS.EDITOR.TASKS.SEND_NOTIFICATIONS.SMB.USERS"
    [dataService]="smbUsersSelectorService"
    [formControl]="usersFormControl"
    [isRequired]="true"
    [disableIfTemplate]="true"
    [multiple]="true"
    [supportDataPassing]="true"
    [supportedDataTypes]="supportedDataTypes"
    (finishedInitialLoading)="finishedInitialLoading()"
  ></automata-automation-replacement-chips>

  <automata-send-notification-form
    #notificationForm
    [partnerId]="automation.namespace"
    [step]="step"
    [defaultLinkTemplate]="'{{business_app_url}}/account/location/{{business_id}}'"
    [userTypeKey]="'AUTOMATIONS.EDITOR.TASKS.SEND_NOTIFICATIONS.USER_TYPES.USERS'"
    [notificationMessagePlaceholderKey]="'AUTOMATIONS.EDITOR.TASKS.SEND_NOTIFICATIONS.SMB.NEW_COMPANY_CREATED'"
    [isSalesperson]="false"
  ></automata-send-notification-form>
</div>
